import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Button } from 'src/components/system/Button';
import { Page, Card, Title, Input, ErrorText } from './styles';
import { resetPassword } from 'src/services/auth';

export function ResetPassword() {
  const [search] = useSearchParams();
  const token = search.get('token') || '';
  const presetEmail = search.get('email') || '';
  const [email, setEmail] = useState(presetEmail);
  const [password, setPassword] = useState('');
  const [password_confirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    try {
      const res = await resetPassword(token, email, password, password_confirmation);
      setMessage(res.status || 'Senha alterada. Faça login.');
    } catch (err: any) {
      setError('Não foi possível redefinir a senha.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Page>
      <Card>
        <Title>Redefinir senha</Title>
        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <Input placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            <Input placeholder="Nova senha" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
            <Input placeholder="Confirmar senha" type="password" value={password_confirmation} onChange={e => setPasswordConfirmation(e.target.value)} required />
            {message && <div>{message}</div>}
            {error && <ErrorText>{error}</ErrorText>}
            <Button
              width="100%"
              backgroundColor="#222B82"
              borderColor="#222B82"
              buttonColor="#fff"
              type="submit"
              disabled={loading}
              label={<span>{loading ? 'Enviando...' : 'Salvar'}</span>}
            />
          </div>
        </form>
        <Link to="/auth/login">Voltar para login</Link>
      </Card>
    </Page>
  );
}

